import PropTypes from 'prop-types';
import React from 'react';
import Loader from '../misc/Loader.react';
import cx from '../../utils/cx.js';
import get from 'lodash/get';

const ReactPropTypes = PropTypes;

class GalleryImage extends React.Component {
  static propTypes = {
    filename: ReactPropTypes.string,
    size: ReactPropTypes.string,
    loadStatus: ReactPropTypes.string,
    sex: ReactPropTypes.string,
    thumb: ReactPropTypes.bool,
    active: ReactPropTypes.bool,
    onClick: ReactPropTypes.func,
    gcloud: ReactPropTypes.bool,
    uncensored: ReactPropTypes.bool,
  };

  static defaultProps = {
    filename: null,
    size: 'h', // h - vislielākā
    sex: null, // f - sieviete, m - vīrietis
    loadStatus: null,
    thumb: false, // thumb bilde (maza)
    active: false, // pazīme, ka aktīva bilde
    onClick: null,
    gcloud: false, // pazīme, ka bilde augšupielādēta Google Cloud
    uncensored: false,
  };

  render() {
    const self = this;
    const targetBasePath = this.props.gcloud ? 'gcloudUri' : 'fullStaticImageUri';
    let filename = this.props.filename;
    if (this.props.gcloud && !filename.includes('jpg')) {
      filename += '.jpg';
    }

    var fullFilename = `${get(globals, targetBasePath, '') + this.props.size}/${filename}`;

    // pievieno dzimuma parametru, lai atgrieztu korektu bildi, ja neizdoas ielādēt
    if (this.props.sex && !this.props.gcloud) {
      fullFilename += `/${this.props.sex}`;
    }


    if (this.props.filename.match(/\.(jpeg|jpg|gif|png)(?:[\?]+[A-Za-z0-9_.-\/=&-]+)?$/) != null && !this.props.gcloud) {
      var fullFilename = this.props.filename;
    }

    const ImageContent = function () {
      if (self.props.loadStatus == null) {
        return (
          <div>
            <Loader large center />
          </div>
        );
      }

      return (
        <div
          className={cx([
            'galleryImage-inner',
            ['galleryImage-inner--uncensored', self.props.uncensored],
          ])}
        >
          <img src={fullFilename} alt="" />
        </div>
      );
    };

    return (
      <div
        className={cx([
          'galleryImage',
          ['galleryImage--thumb', this.props.thumb],
        ])}
        onClick={this.props.onClick}
      >
        {ImageContent()}
      </div>
    );
  }
}

module.exports = GalleryImage;
